// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    url: '//reservation.makrooads.com',
    production: true,
    apiEndpoint: 'http://api.makrooads.com/v1',
    ownerApiEndpoint: 'http://api.makrooads.com/owner',
    webSocketUrl: 'http://93.115.76.114:9060'

    /*url: 'http://localhost:5000',
    production: false,
    apiEndpoint: '//localhost:5000/v1',
    ownerApiEndpoint: '//localhost:5000/owner',
    webSocketUrl: '//localhost:5050'*/
};



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/environments/environment.ts